import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "toggle"];

  connect() {
    this.expanded = false;
    this.setupInitialState();
  }

  setupInitialState() {
    // Store the full text
    this.fullText = this.textTarget.textContent.trim();

    // Create truncated version (22 words)
    const words = this.fullText.split(" ");
    const truncatedWords = words.slice(0, 22);
    this.truncatedText = truncatedWords.join(" ");

    // Only show "Read more" if text is actually truncated
    if (words.length > 22) {
      this.textTarget.textContent = this.truncatedText + "...";
      this.toggleTarget.classList.remove("hidden");
    } else {
      this.toggleTarget.classList.add("hidden");
    }
  }

  toggle() {
    if (this.expanded) {
      // Collapse
      this.textTarget.textContent = this.truncatedText + "...";
      this.toggleTarget.textContent = "Read more...";
      this.expanded = false;
    } else {
      // Expand
      this.textTarget.textContent = this.fullText;
      this.toggleTarget.textContent = "Show less";
      this.expanded = true;
    }
  }
}
